<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">澄清文件</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回</el-button>
        </div>
        <div class="content-wrap">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px" class="bid-form">
                <div class="form-row">
                    <!-- 左列 -->
                    <div class="form-column">
                        <!-- <el-form-item label="招标项目名称:" prop="projectName">
                            <el-input v-model="form.projectName" placeholder="请输入招标项目名称" disabled></el-input>
                        </el-form-item> -->
                        <el-form-item label="澄清公告名称:" prop="bidInvitationDocumentsName" required>
                            <el-input v-model="form.bidInvitationDocumentsName" placeholder="请输入招标文件名称"
                                :disabled="isViewMode"></el-input>
                        </el-form-item>
                        <el-form-item v-if="!$route.query.bidInvitationDocumentsCode" label="适用招标文件:" required>
                            <el-select v-model="selectedBidDocumentCode" placeholder="请选择招标文件"
                                style="width: 100%" @change="handleBidDocumentChange" :disabled="isViewMode">
                                <el-option v-for="item in clarificationBidDocumentList"
                                    :key="item.bidInvitationDocumentsCode"
                                    :label="item.bidInvitationDocumentsName"
                                    :value="item.bidInvitationDocumentsCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="适用标段:" prop="bidSection" required>
                            <el-select v-model="form.bidSection" placeholder="请选择标段" style="width: 100%" multiple
                                collapse-tags collapse-tags-tooltip :disabled="isViewMode">
                                <el-option v-for="item in bidSectionList" :key="item.bidSectionCode"
                                    :label="item.bidSectionName" :value="item.bidSectionCode"></el-option>
                            </el-select>
                        </el-form-item>

                        <!-- 适用文件 -->
                        <el-form-item label="开标/递交截止时间:" prop="deadline" required>
                            <app-date-picker v-model="form.deadline" type="datetime" placeholder="选择日期时间"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                                @change="handleDeadlineChange" style="width: 100%" :disabled="isViewMode">
                            </app-date-picker>
                        </el-form-item>

                        <el-form-item label="投标限价:" prop="tenderControlPrice" required>
                            <el-input v-model="form.tenderControlPrice" placeholder="请输入投标限价" :disabled="isViewMode">
                                <template slot="prepend">
                                    <el-select v-model="form.tenderControlPriceType" style="width: 80px;"
                                        @change="handlePriceTypeChange" :disabled="isViewMode">
                                        <el-option label="金额" :value="1"></el-option>
                                        <el-option label="费率" :value="2"></el-option>
                                    </el-select>
                                </template>
                                <template slot="append">
                                    <el-select v-if="form.tenderControlPriceType === 1"
                                        v-model="form.tenderControlPriceUnit" style="width: 80px;"
                                        :disabled="isViewMode">
                                        <el-option label="元" :value="0"></el-option>
                                        <el-option label="万元" :value="1"></el-option>
                                    </el-select>
                                    <span v-else style="padding: 0 8px;">%</span>
                                </template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <!-- 右列 -->
                    <div class="form-column">
                        <!-- <el-form-item label="专家评标形式:" prop="evaluationType">
                            <el-checkbox v-model="form.isBlindBid" :disabled="isViewMode">暗标(自动分为商务标和技术标)</el-checkbox>
                        </el-form-item> -->
                        <el-form-item label="解密截止时间:" prop="decryptionDeadline" required>
                            <app-date-picker v-model="form.decryptionDeadline" type="datetime"
                                :placeholder="form.deadline ? '选择解密截止时间' : '请先选择开标/递交截止时间'" format="yyyy-MM-dd HH:mm:ss"
                                value-format="yyyy-MM-dd HH:mm:ss" @change="handleDecryptionDeadlineChange"
                                style="width: 100%;" :disabled="isViewMode || !form.deadline" />
                        </el-form-item>
                        <el-form-item label="质疑截止时间:" prop="questionDeadline" required>
                            <app-date-picker v-model="form.questionDeadline" type="datetime" placeholder="选择质疑截止时间"
                                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%;"
                                :disabled="isViewMode" />
                        </el-form-item>
                        <el-form-item label="澄清内容:" prop="content" required>
                            <div v-if="isViewMode" class="rich-text-readonly" v-html="form.content || '暂无内容'"></div>
                            <rich-text-editor v-else v-model="form.content" placeholder="请输入澄清内容" :height="240">
                            </rich-text-editor>
                        </el-form-item>
                    </div>
                </div>

                <el-form-item label="招标文件:" prop="tenderFile">
                    <div class="upload-section">
                        <div class="upload-buttons" v-if="!isViewMode">
                            <el-button type="primary" icon="el-icon-upload2" size="small"
                                @click="handleUpload('word', $tenderFileType.CLARIFICATION_MAIN_FILE)"
                                :disabled="hasWordMain">上传Word</el-button>
                            <div class="upload-tip">* 请上传word格式文件（仅限1份）!</div>

                            <el-button type="primary" icon="el-icon-upload2" size="small"
                                @click="handleUpload('pdf', $tenderFileType.CLARIFICATION_MAIN_FILE)"
                                :disabled="hasPdfMain">上传PDF</el-button>
                            <div class="upload-tip">* 请上传pdf格式文件（仅限1份）!</div>

                            <el-button type="primary" size="small" @click="showDirectoryDialog">投标文件目录</el-button>
                            <div class="upload-tip">* 请上传投标文件目录!</div>

                            <el-button type="primary" size="small"
                                @click="handleUpload('attachment', $tenderFileType.CLARIFICATION_ATTACHMENT)">附件上传</el-button>
                            <!-- <el-button type="primary" size="small" @click="dialogs.blindRequirement = true"
                                v-if="isBlindReviewEnabled && !isViewMode">暗标编制要求</el-button> -->
                        </div>
                        <!-- 已上传文件列表 -->
                        <div v-if="uploadedFiles.length > 0" class="uploaded-files-list">
                            <!-- 招标文件正文 -->
                            <div v-if="mainFiles.length > 0" class="file-group">
                                <div class="file-group-header">
                                    <i class="el-icon-document"></i>
                                    <span>招标文件正文</span>
                                    <el-tag size="mini" type="info" style="margin-left:8px;">{{ mainFiles.length }} 份</el-tag>
                                </div>
                                <el-table :data="mainFiles" border size="small">
                                    <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                                    <el-table-column label="格式" width="80" align="center">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" :type="scope.row.fileType === 'pdf' ? 'danger' : 'primary'">
                                                {{ scope.row.fileType.toUpperCase() }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="大小" width="90" align="center">
                                        <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="90" align="center">
                                        <template slot-scope="scope">
                                            <el-button v-if="isViewMode" type="text" size="small"
                                                @click="handleDownloadUploadedFile(scope.row)">下载</el-button>
                                            <el-button v-else type="text" size="small" style="color:#F56C6C;"
                                                @click="handleDeleteFile(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!-- 附件 -->
                            <div v-if="attFiles.length > 0" class="file-group">
                                <div class="file-group-header">
                                    <i class="el-icon-paperclip"></i>
                                    <span>附件</span>
                                    <el-tag size="mini" type="info" style="margin-left:8px;">{{ attFiles.length }} 份</el-tag>
                                </div>
                                <el-table :data="attFiles" border size="small">
                                    <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip></el-table-column>
                                    <el-table-column label="格式" width="80" align="center">
                                        <template slot-scope="scope">
                                            <el-tag size="mini" :type="scope.row.fileType === 'pdf' ? 'danger' : scope.row.fileType === 'docx' || scope.row.fileType === 'doc' ? 'primary' : 'warning'">
                                                {{ scope.row.fileType.toUpperCase() }}
                                            </el-tag>
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="大小" width="90" align="center">
                                        <template slot-scope="scope">{{ formatFileSize(scope.row.fileSize) }}</template>
                                    </el-table-column>
                                    <el-table-column label="操作" width="90" align="center">
                                        <template slot-scope="scope">
                                            <el-button v-if="isViewMode" type="text" size="small"
                                                @click="handleDownloadUploadedFile(scope.row)">下载</el-button>
                                            <el-button v-else type="text" size="small" style="color:#F56C6C;"
                                                @click="handleDeleteFile(scope.row)">删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <!-- 开标一览表 -->
                <div class="opening-summary">
                    <div class="summary-title">开标一览表:</div>
                    <el-table :data="openingSummaryData" border>
                        <el-table-column prop="name" label="名称">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.name" size="small" placeholder="请输入名称"
                                    :disabled="isViewMode">
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="valueType" label="数值类型">
                            <template slot-scope="scope">
                                <span>{{ scope.row.valueType }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="unit" label="单位">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.unit" size="small" placeholder="请输入单位"
                                    :disabled="isViewMode">
                                </el-input>
                            </template>
                        </el-table-column>
                        <el-table-column prop="instructions" label="填写说明">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.instructions" size="small" placeholder="请输入填写说明"
                                    :disabled="isViewMode">
                                </el-input>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="type" label="类型">
                            <template slot-scope="scope">
                                <span>{{ scope.row.type }}</span>
                            </template>
                        </el-table-column> -->
                        <el-table-column label="操作" width="150" v-if="!isViewMode">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="deleteSummaryItem(scope.$index)">
                                    <i class="el-icon-delete"></i>
                                </el-button>
                                <el-button v-if="scope.$index > 0" type="text" size="small"
                                    @click="moveSummaryItem(scope.$index, 'up')">
                                    <i class="el-icon-top"></i>
                                </el-button>
                                <el-button v-if="scope.$index < openingSummaryData.length - 1" type="text" size="small"
                                    @click="moveSummaryItem(scope.$index, 'down')">
                                    <i class="el-icon-bottom"></i>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="add-summary-btn" v-if="!isViewMode">
                        <el-button type="primary" size="small" @click="showAddDialog">添加自定义开标内容</el-button>
                    </div>
                </div>

                <!-- 底部按钮 -->
                <div class="form-actions" v-if="!isViewMode">
                    <el-button @click="handleSubmit(0)">暂存</el-button>
                    <el-button type="primary" @click="handleSubmit(1)">提交</el-button>
                </div>
            </el-form>
        </div>
        <!-- 添加自定义开标内容弹窗 -->
        <el-dialog title="消息确认" :visible.sync="dialogs.add" width="500px" :close-on-click-modal="false"
            :append-to-body="true" class="add-dialog">
            <div class="dialog-content">
                <div class="dialog-title">*添加自定义内容的类型:</div>
                <el-radio-group v-model="addDialogData.selectedType" class="type-radio-group">
                    <div class="radio-row">
                        <el-radio label="总价">总价</el-radio>
                        <el-radio label="费率">费率</el-radio>
                        <el-radio label="单价">单价</el-radio>
                    </div>
                    <div class="radio-row">
                        <el-radio label="证书编号">证书编号</el-radio>
                        <el-radio label="交货地点">交货地点</el-radio>
                    </div>
                    <div class="radio-row">
                        <el-radio label="期限(服务/交货/工期)">期限(服务/交货/工期)</el-radio>
                        <el-radio label="其它">其它</el-radio>
                    </div>
                    <div class="radio-row">
                        <el-radio label="姓名">姓名</el-radio>
                        <el-radio label="质量标准">质量标准</el-radio>
                    </div>
                </el-radio-group>
                <div v-if="!addDialogData.selectedType" class="error-message">请选择自定义内容的类型</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmAdd">确认</el-button>
                <el-button @click="cancelAdd">取消</el-button>
            </div>
        </el-dialog>
        <!-- 选择引用的招标文件弹窗 -->
        <el-dialog title="选择引用的招标文件" :visible.sync="dialogs.reference" width="700px" :append-to-body="true"
            class="reference-dialog">
            <div class="dialog-content">
                <el-table :data="referenceData.tableData" v-loading="referenceData.loading" border style="width: 100%"
                    class="reference-table">
                    <el-table-column prop="no" label="NO." width="60" align="center" />
                    <el-table-column prop="fileName" label="文件名称" show-overflow-tooltip />
                    <el-table-column label="详细信息" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleSelectReference(scope.row)"
                                class="select-btn">
                                选择引用
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 分页 -->
                <div class="reference-pagination">
                    <el-pagination @size-change="handleReferenceSizeChange"
                        @current-change="handleReferenceCurrentChange"
                        :current-page="referenceData.pagination.currentPage" :page-sizes="[10, 20, 50, 100]"
                        :page-size="referenceData.pagination.pageSize" layout="total, sizes, prev, pager, next, jumper"
                        :total="referenceData.pagination.total" class="reference-pagination-controls" />
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancelReference">取消</el-button>
            </div>
        </el-dialog>
        <!-- 投标文件目录目录管理弹窗 -->
        <el-dialog title="投标文件目录目录管理" :visible.sync="dialogs.directory" width="60%" :append-to-body="true"
            class="directory-dialog">
            <div class="dialog-content">
                <div class="directory-block-header">
                    <div><div class="directory-block-title">投标文件目录</div></div>
                    <div class="directory-toolbar compact">
                        <el-button type="primary" size="small" icon="el-icon-plus"
                            @click="addRootDirectory('normal')">添加目录</el-button>
                        <el-button size="small" icon="el-icon-document-copy"
                            @click="openPasteDirectoryDialog('normal')">粘贴目录</el-button>
                    </div>
                </div>
                <div class="directory-tree">
                    <div v-if="directoryData.treeData.length === 0" class="empty-directory">
                        <i class="el-icon-folder-opened"></i>
                        <p>暂无目录</p>
                    </div>
                    <div v-else class="directory-list">
                        <div v-for="(item, index) in directoryData.treeData" :key="item.id" class="directory-item">
                            <div class="directory-node">
                                <i class="el-icon-folder"></i>
                                <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === item.id"
                                    v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(item)"
                                    @keyup.enter.native="saveDirectoryName(item)" ref="directoryInput"
                                    class="directory-input">
                                </el-input>
                                <span v-else class="directory-name">{{ item.name }}</span>
                                <div class="directory-actions">
                                    <el-button type="text" size="small" icon="el-icon-edit"
                                        @click="editDirectoryName(item)"
                                        v-if="!directoryData.editingNode || directoryData.editingNode.id !== item.id">
                                    </el-button>
                                    <el-button type="text" size="small" icon="el-icon-plus"
                                        @click="addChildDirectory(item)">
                                    </el-button>
                                    <el-button type="text" size="small" icon="el-icon-delete"
                                        @click="deleteDirectory(item, index)">
                                    </el-button>
                                </div>
                            </div>
                            <!-- 子目录 -->
                            <div v-if="item.children && item.children.length > 0" class="directory-children">
                                <div v-for="(child, childIndex) in item.children" :key="child.id"
                                    class="directory-item child-item">
                                    <div class="directory-node">
                                        <i class="el-icon-folder"></i>
                                        <el-input
                                            v-if="directoryData.editingNode && directoryData.editingNode.id === child.id"
                                            v-model="directoryData.editingName" size="small"
                                            @blur="saveDirectoryName(child)"
                                            @keyup.enter.native="saveDirectoryName(child)" ref="directoryInput"
                                            class="directory-input">
                                        </el-input>
                                        <span v-else class="directory-name">{{ child.name }}</span>
                                        <div class="directory-actions">
                                            <el-button type="text" size="small" icon="el-icon-edit"
                                                @click="editDirectoryName(child)"
                                                v-if="!directoryData.editingNode || directoryData.editingNode.id !== child.id">
                                            </el-button>
                                            <el-button type="text" size="small" icon="el-icon-plus"
                                                @click="addChildDirectory(child)">
                                            </el-button>
                                            <el-button type="text" size="small" icon="el-icon-delete"
                                                @click="deleteChildDirectory(item, child, childIndex)">
                                            </el-button>
                                        </div>
                                    </div>
                                    <!-- 三级子目录 -->
                                    <div v-if="child.children && child.children.length > 0" class="directory-children">
                                        <div v-for="(grandchild, grandchildIndex) in child.children"
                                            :key="grandchild.id" class="directory-item grandchild-item">
                                            <div class="directory-node">
                                                <i class="el-icon-folder"></i>
                                                <el-input
                                                    v-if="directoryData.editingNode && directoryData.editingNode.id === grandchild.id"
                                                    v-model="directoryData.editingName" size="small"
                                                    @blur="saveDirectoryName(grandchild)"
                                                    @keyup.enter.native="saveDirectoryName(grandchild)"
                                                    ref="directoryInput" class="directory-input">
                                                </el-input>
                                                <span v-else class="directory-name">{{ grandchild.name }}</span>
                                                <div class="directory-actions">
                                                    <el-button type="text" size="small" icon="el-icon-edit"
                                                        @click="editDirectoryName(grandchild)"
                                                        v-if="!directoryData.editingNode || directoryData.editingNode.id !== grandchild.id">
                                                    </el-button>
                                                    <el-button type="text" size="small" icon="el-icon-delete"
                                                        @click="deleteGrandchildDirectory(child, grandchild, grandchildIndex)">
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 暗标文件目录 -->
                  <!-- isBlindReviewEnabled -->
            <div class="directory-block" v-if="IS_BLIND_DIRECTORY_ENABLED">
                <div class="directory-block-header">
                    <div>
                        <div class="directory-block-title">暗标目录</div>
                    </div>
                    <div class="directory-toolbar compact">
                        <!-- <span class="directory-block-tip" style="color:#909399;">暗标无需设置目录</span> -->
                    </div>
                </div>
                <div class="directory-tree">
                    <div v-if="directoryData.blindTreeData.length === 0" class="empty-directory">
                        <i class="el-icon-folder-opened"></i>
                        <p>暗标无需设置目录</p>
                    </div>
                    <div v-else class="directory-list">
                        <div v-for="(item, index) in directoryData.blindTreeData" :key="item.id" class="directory-item">
                            <div class="directory-node">
                                <i class="el-icon-folder"></i>
                                <el-input v-if="directoryData.editingNode && directoryData.editingNode.id === item.id"
                                    v-model="directoryData.editingName" size="small" @blur="saveDirectoryName(item)"
                                    @keyup.enter.native="saveDirectoryName(item)" ref="directoryInput"
                                    class="directory-input">
                                </el-input>
                                <span v-else class="directory-name">{{ item.name }}</span>
                                <div class="directory-actions">
                                    <el-button type="text" size="small" icon="el-icon-edit"
                                        @click="editDirectoryName(item)"
                                        v-if="!directoryData.editingNode || directoryData.editingNode.id !== item.id">
                                    </el-button>
                                    <el-button type="text" size="small" icon="el-icon-plus"
                                        @click="addChildDirectory(item)">
                                    </el-button>
                                    <el-button type="text" size="small" icon="el-icon-delete"
                                        @click="deleteBlindDirectory(item, index)">
                                    </el-button>
                                </div>
                            </div>
                            <div v-if="item.children && item.children.length > 0" class="directory-children">
                                <div v-for="(child, childIndex) in item.children" :key="child.id"
                                    class="directory-item child-item">
                                    <div class="directory-node">
                                        <i class="el-icon-folder"></i>
                                        <el-input
                                            v-if="directoryData.editingNode && directoryData.editingNode.id === child.id"
                                            v-model="directoryData.editingName" size="small"
                                            @blur="saveDirectoryName(child)"
                                            @keyup.enter.native="saveDirectoryName(child)" ref="directoryInput"
                                            class="directory-input">
                                        </el-input>
                                        <span v-else class="directory-name">{{ child.name }}</span>
                                        <div class="directory-actions">
                                            <el-button type="text" size="small" icon="el-icon-edit"
                                                @click="editDirectoryName(child)"
                                                v-if="!directoryData.editingNode || directoryData.editingNode.id !== child.id">
                                            </el-button>
                                            <el-button type="text" size="small" icon="el-icon-plus"
                                                @click="addChildDirectory(child)">
                                            </el-button>
                                            <el-button type="text" size="small" icon="el-icon-delete"
                                                @click="deleteChildDirectory(item, child, childIndex)">
                                            </el-button>
                                        </div>
                                    </div>
                                    <div v-if="child.children && child.children.length > 0" class="directory-children">
                                        <div v-for="(grandchild, grandchildIndex) in child.children"
                                            :key="grandchild.id" class="directory-item grandchild-item">
                                            <div class="directory-node">
                                                <i class="el-icon-folder"></i>
                                                <el-input
                                                    v-if="directoryData.editingNode && directoryData.editingNode.id === grandchild.id"
                                                    v-model="directoryData.editingName" size="small"
                                                    @blur="saveDirectoryName(grandchild)"
                                                    @keyup.enter.native="saveDirectoryName(grandchild)"
                                                    ref="directoryInput" class="directory-input">
                                                </el-input>
                                                <span v-else class="directory-name">{{ grandchild.name }}</span>
                                                <div class="directory-actions">
                                                    <el-button type="text" size="small" icon="el-icon-edit"
                                                        @click="editDirectoryName(grandchild)"
                                                        v-if="!directoryData.editingNode || directoryData.editingNode.id !== grandchild.id">
                                                    </el-button>
                                                    <el-button type="text" size="small" icon="el-icon-delete"
                                                        @click="deleteGrandchildDirectory(child, grandchild, grandchildIndex)">
                                                    </el-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmDirectory">确认</el-button>
                <el-button @click="cancelDirectory">取消</el-button>
            </div>
        </el-dialog>

        <!-- 粘贴目录弹窗 -->
        <el-dialog title="粘贴目录" :visible.sync="dialogs.pasteDirectory" width="640px" :append-to-body="true"
            class="paste-directory-dialog" :close-on-click-modal="false">
            <div class="paste-directory-content">
                <div class="paste-directory-tip">支持格式示例：一、法定代表人身份证明书 / 1、营业执照 / 二、授权委托书</div>
                <el-input type="textarea" :rows="12" v-model="directoryData.pasteContent"
                    placeholder="请粘贴目录文本，一行一个目录"></el-input>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="confirmPasteDirectory">确定</el-button>
                <el-button @click="cancelPasteDirectory">取消</el-button>
            </div>
        </el-dialog>

        <!-- 暗标编制要求弹窗 -->
        <el-dialog title="暗标编制要求" :visible.sync="dialogs.blindRequirement" width="640px" :append-to-body="true"
            :close-on-click-modal="false" class="blind-requirement-dialog">
            <el-input type="textarea" v-model="form.remark" :rows="10" :maxlength="1000" show-word-limit
                placeholder="请输入暗标编制要求"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogs.blindRequirement = false">确定</el-button>
                <el-button @click="dialogs.blindRequirement = false">取消</el-button>
            </div>
        </el-dialog>

        <!-- 文件上传进度对话框 -->
        <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true"
            :show-close="uploadProgress.status === uploadConstants.UPLOAD_STATUS.ERROR || uploadProgress.status === uploadConstants.UPLOAD_STATUS.SUCCESS">
            <div class="upload-progress-content">
                <div class="upload-info">
                    <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
                    <span>{{ uploadProgress.fileName }}</span>
                </div>
                <el-progress :percentage="uploadProgress.percentage"
                    :status="uploadProgress.status === uploadConstants.UPLOAD_STATUS.SUCCESS ? 'success' : (uploadProgress.status === uploadConstants.UPLOAD_STATUS.ERROR ? 'exception' : null)"
                    style="margin-top: 20px;">
                </el-progress>
                <div class="upload-status" style="margin-top: 10px; text-align: center;">
                    <span v-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.UPLOADING">正在上传...</span>
                    <span v-else-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.SUCCESS"
                        style="color: #67C23A;">上传成功</span>
                    <span v-else-if="uploadProgress.status === uploadConstants.UPLOAD_STATUS.ERROR"
                        style="color: #F56C6C;">上传失败</span>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// API
import {
    getProjectDetail,
    getClarificationDetail,
    addBidInvitationDocumentsClarification,
    initClarificationData,
    getBidInvitationDocumentsDetail
} from '@/api/modules/agent'
import { getFileList } from '@/api/modules/base'
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { deleteBidAtt } from '@/api/modules/make'

// Utils
import { getProjectTypeName, timeUtils, UPLOAD_CONSTANTS, BUSINESS_CONSTANTS } from '@/utils/base'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'

// Element UI
import Vue from 'vue'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'

Vue.use(ElementUI, { locale })

// 提交时：本地显示值 → 接口字段值
const TYPE_MAPPING = { '总价': '1', '费率': '2', '单价': '3', '其它': '9', '证书编号': '9', '交货地点': '9', '期限(服务/交货/工期)': '9', '姓名': '9', '质量标准': '11' }
const UNIT_MAPPING = { '元': 0, '万元': 1, '%': 2 }
const VALUE_TYPE_MAPPING = { '任意格式文本': 0, '数字含小数': 1, '数字及字母X': 1 }
const REVERSE_TYPE_MAPPING = { '1': '总价', '2': '费率', '3': '单价', '11': '质量标准' }
const REVERSE_UNIT_MAPPING = { 0: '元', 1: '万元', 2: '%' }
const REVERSE_VALUE_TYPE_MAPPING = { 0: '任意格式文本', 1: '数字含小数' }
// 暗标目录暂时隐藏
const IS_BLIND_DIRECTORY_ENABLED = true

export default {
    name: 'ClarificationFile',
    components: {
        RichTextEditor
    },
    data() {
        return {
            // 页面基础信息
            pageTitle: '',
            isViewMode: false,
            projectCode: '',

            // 项目详情数据
            projectDetail: {},

            matchedDocument: [], // 选择的招标文件列表

            // 标段列表
            bidSectionList: [],

            // 加载状态
            loading: false,

            // 表单数据
            form: {
                projectName: '',
                bidInvitationDocumentsName: '',
                bidInvitationDocumentsCode: '',
                bidSection: [],
                deadline: '',
                tenderControlPrice: '',
                tenderControlPriceType: 1,
                tenderControlPriceUnit: 0,
                tenderFile: '',
                isBlindBid: false,
                decryptionDeadline: '',
                questionDeadline: '',
                referenceFile: '',
                content: '',
                remark: ''
            },

            // 开标一览表数据
            openingSummaryData: [
                { name: '总价', valueType: '数字含小数', unit: '元', instructions: '', type: '总价' },
                { name: '总价(大写)', valueType: '任意格式文本', unit: '元', instructions: '', type: '其它' },
                { name: '工期', valueType: '任意格式文本', unit: '', instructions: '', type: '期限(服务/交货/工期)' },
                { name: '质量标准', valueType: '任意格式文本', unit: '', instructions: '', type: '其它' }
            ],
            clarificationBidDocumentList: [],
            selectedBidDocumentCode: '',
            // 弹窗控制
            dialogs: {
                add: false,
                reference: false,
                directory: false,
                pasteDirectory: false,
                blindRequirement: false
            },

            // 添加弹窗相关数据
            addDialogData: {
                selectedType: ''
            },

            // 引用弹窗相关数据
            referenceData: {
                loading: false,
                tableData: [
                    {
                        no: 1,
                        fileName: ''
                    }
                ],
                pagination: {
                    currentPage: 1,
                    pageSize: 10,
                    total: 1
                }
            },

            // 目录管理相关数据
            directoryData: {
                treeData: [], // 目录树数据
                blindTreeData: [], // 暗标目录树数据
                editingNode: null, // 正在编辑的节点
                editingName: '', // 编辑中的目录名称
                pasteContent: '', // 粘贴目录文本
                pasteTarget: 'normal' // 粘贴目录目标 'normal' | 'blind'
            },

            // 操作状态
            operationStatus: {
                isSubmitting: false
            },

            // 文件上传相关数据
            fileBindId: '', // 文件绑定ID
            uploadedFiles: [], // 已上传文件列表
            tenderFileType: '', // 文件类型标识（main_file 或 attachment）
            uploadProgress: {
                visible: false, // 是否显示上传进度弹窗
                percentage: 0, // 上传进度
                fileName: '', // 文件名称
                status: null // 上传状态
            },
            uploadConstants: {
                ...UPLOAD_CONSTANTS,
                ...BUSINESS_CONSTANTS,
                UPLOAD_STATUS: UPLOAD_CONSTANTS.STATUS
            },

            // 类型对应的数据格式配置
            typeConfig: {
                '总价': { valueType: '数字含小数', unit: '元' },
                '费率': { valueType: '数字含小数', unit: '%' },
                '单价': { valueType: '数字含小数', unit: '元' },
                '证书编号': { valueType: '数字及字母X', unit: '' },
                '交货地点': { valueType: '任意格式文本', unit: '' },
                '期限(服务/交货/工期)': { valueType: '任意格式文本', unit: '' },
                '其它': { valueType: '任意格式文本', unit: '' },
                '姓名': { valueType: '任意格式文本', unit: '' },
                '质量标准': { valueType: '任意格式文本', unit: '' }
            },

            // 表单验证规则（不设置 trigger，只在提交时手动验证）
            rules: {
                bidInvitationDocumentsName: [
                    { required: true, message: '请输入招标文件名称' }
                ],
                bidSection: [
                    { required: true, message: '请选择标段' },
                    { type: 'array', min: 1, message: '请至少选择一个标段' }
                ],
                deadline: [
                    { required: true, message: '请选择开标/递交截止时间' }
                ],
                tenderControlPrice: [
                    { required: true, message: '请输入投标限价' },
                    { validator: this.validateBidLimit }
                ],
                decryptionDeadline: [
                    { required: true, message: '请选择解密截止时间' },
                    { validator: this.validateDecryptionDeadline }
                ],
                questionDeadline: [
                    { required: true, message: '请选择质疑截止时间' }
                ],
                content: [
                    { validator: this.validateRichTextContent }
                ]
            }
        }
    },
    mounted() {
        this.initPage()
    },

    watch: {
        'form.bidSection'() {
            this.syncBlindReviewBySelectedSection()
        }
    },

    computed: {
        isBlindReviewEnabled() {
            return this.form.isBlindBid === true
        },
        mainFiles() {
            return this.uploadedFiles.filter(f => f.tenderFileType === this.$tenderFileType.CLARIFICATION_MAIN_FILE)
        },
        attFiles() {
            return this.uploadedFiles.filter(f => f.tenderFileType === this.$tenderFileType.CLARIFICATION_ATTACHMENT)
        },
        hasPdfMain() {
            return this.mainFiles.some(f => f.fileType === 'pdf')
        },
        hasWordMain() {
            return this.mainFiles.some(f => f.fileType === 'doc' || f.fileType === 'docx')
        },
        channelCode() {
      return this.$channelMaterial.getChannelCode()
    },
    },

    methods: {
        // ==================== 页面初始化相关 ====================

        // 初始化页面
        async initPage() {
            const projectCode = this.$route.query.projectCode
            if (!projectCode) {
                this.$message.error('缺少项目编号参数')
                this.$router.go(-1)
                return
            }
            this.projectCode = projectCode
            await this.loadProjectDetail()
            this.isViewMode = this.$route.query.isViewMode === 'true' || this.$route.query.isViewMode === true
            const bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode
        console.log('------查看');

          console.log(bidInvitationDocumentsCode);
            console.log('------查看');
        
            if (bidInvitationDocumentsCode) {
                // 编辑或详情模式：有文件编号，加载已有数据（fileBindId 由接口返回覆盖）
                this.initClarificationViewMode(projectCode)
            } else {
                // 新增模式：生成新的文件绑定ID
                this.fileBindId = Date.now().toString() + Math.floor(Math.random() * 100000)
                this.initClarificationData(projectCode)
            }
        },

        // 初始化查看模式
        async initClarificationViewMode(projectCode) {
            const code = this.$route.query.bidInvitationDocumentsCode
            if (!code) {
                this.$message.error('缺少文件编号参数')
                return
            }
            try {
                const res = await getClarificationDetail(code)
                if (res.code === 200) {
                    const data = res.data || {}
                    const bidSectionConfig = data.bidSectionConfig || {}
                    const bidSectionCode = bidSectionConfig.bidSectionCode
                    await this.getBidInvitationDocumentsDetail(code)
                    await this.initClarificationData(projectCode, bidSectionCode)
                } else {
                    this.$handleApiError(res, '获取澄清-补遗 文件数据失败', this)
                }
            } catch (error) {
                this.$handleError(error, '获取澄清-补遗 文件数据失败', this)
            }
        },

        // 初始化澄清数据
        async initClarificationData(projectCode, bidSectionCode) {
            try {
                const res = await initClarificationData(projectCode)
                if (res.code === 200) {
                    const data = res.data || {}
                    const bidDocumentList = Array.isArray(data.bidDocumentList) ? data.bidDocumentList : []

                    if (!bidSectionCode) {
                        // 新增模式：仅加载招标文件列表供用户选择，其余内容由用户手动填写
                        this.clarificationBidDocumentList = bidDocumentList
                        return
                    }

                    // 编辑/查看模式：匹配对应招标文件
                    let matchedDocument = bidDocumentList.find(item => {
                        const list = Array.isArray(item.bidSectionList) ? item.bidSectionList : []
                        return list.some(s => s && s.bidSectionCode === bidSectionCode)
                    })
                    if (!matchedDocument) {
                        const targetCode = this.$route.query.bidInvitationDocumentsCode
                        matchedDocument = bidDocumentList.find(item => item.bidInvitationDocumentsCode === targetCode)
                    }
                    this.matchedDocument = matchedDocument
                    if (matchedDocument) {
                        this.bidSectionList = Array.isArray(matchedDocument.bidSectionList) ? matchedDocument.bidSectionList : []
                        const targetSection = this.bidSectionList.find(s => s && s.bidSectionCode === bidSectionCode)
                        this.form.bidSection = targetSection ? [bidSectionCode] : []
                        if (matchedDocument.bidInvitationDocumentsName) {
                            this.form.bidInvitationDocumentsName = matchedDocument.bidInvitationDocumentsName
                        }
                    } else {
                        this.$message.warning('未找到对应的招标文件信息')
                        this.bidSectionList = []
                        this.form.bidSection = []
                    }
                } else {
                    this.$handleApiError(res, '获取澄清-补遗 文件数据失败', this)
                }
            } catch (error) {
                this.$handleError(error, '获取澄清-补遗 文件数据失败', this)
            }
        },

        // 选择招标文件时更新标段列表
        handleBidDocumentChange(code) {
            const doc = (this.clarificationBidDocumentList || []).find(d => d.bidInvitationDocumentsCode === code)
            if (doc) {
                this.matchedDocument = doc
                this.bidSectionList = Array.isArray(doc.bidSectionList) ? doc.bidSectionList : []
                this.form.bidSection = this.bidSectionList.map(s => s.bidSectionCode)
            } else {
                this.matchedDocument = null
                this.bidSectionList = []
                this.form.bidSection = []
            }
        },

        // ========== 公共数据回填方法 ==========

        // 回填时间、投标限价、暗标标志
        fillFormFromConfig(data, { skipQuestionDeadline = false } = {}) {
            const cfg = data.bidSectionConfig || {}
            this.form.deadline = cfg.bidOpeningTime || data.bidOpeningTime || this.form.deadline || ''
            this.form.decryptionDeadline = cfg.decryptionDeadline || data.decryptionDeadline || this.form.decryptionDeadline || ''
            if (!skipQuestionDeadline) {
                this.form.questionDeadline = cfg.questionDeadline || data.questionDeadline || this.form.questionDeadline || ''
            }
            if (cfg.tenderControlPrice != null) {
                this.form.tenderControlPrice = String(cfg.tenderControlPrice)
            }
            if (cfg.tenderControlPriceType != null) {
                this.form.tenderControlPriceType = cfg.tenderControlPriceType
            }
            if (cfg.tenderControlPriceUnit != null) {
                this.form.tenderControlPriceUnit = cfg.tenderControlPriceUnit
            }
            if (cfg.isBlindReview != null) {
                this.form.isBlindBid = Number(cfg.isBlindReview) === 1
            }
        },

        // 回填开标一览表
        fillOpeningSummary(bidOpeningLists) {
            const list = Array.isArray(bidOpeningLists) ? bidOpeningLists : []
            if (list.length > 0) {
                this.openingSummaryData = list.map(item => {
                    const typeKey = item.itemType == null ? '' : String(item.itemType)
                    return {
                        name: item.itemName || '',
                        valueType: REVERSE_VALUE_TYPE_MAPPING[item.itemValueType] || '任意格式文本',
                        unit: REVERSE_UNIT_MAPPING[item.itemUnit] || '',
                        instructions: item.itemInstructions || '',
                        type: REVERSE_TYPE_MAPPING[typeKey] || '其它'
                    }
                })
            }
        },

        // 回填目录树
        fillDirectoryTree(catalogues) {
            const list = Array.isArray(catalogues) ? catalogues : []
            if (list.length > 0) {
                const mapNode = (cat) => ({
                    id: cat.id || cat.strId || cat.catalogueCode || undefined,
                    name: cat.catalogueName || '',
                    children: Array.isArray(cat.children) ? cat.children.map(mapNode) : []
                })
                const normalList = list.filter(c => Number(c.isBlindReview || 0) !== 1)
                const blindList = list.filter(c => Number(c.isBlindReview || 0) === 1)
                this.directoryData.treeData = normalList.map(mapNode)
                this.directoryData.blindTreeData = blindList.map(mapNode)
            }
        },

        // 回填附件列表
        fillFileAttachments(fileGuid) {
            if (fileGuid) {
                this.fileBindId = fileGuid
                this.getFileList(fileGuid)
            }
        },

        // ========== 详情加载方法 ==========

        // 加载原始招标文件详情（新增模式预填，跳过质疑截止时间）
        async loadOriginalDocumentDetail(bidInvitationDocumentsCode) {
            try {
                const res = await getBidInvitationDocumentsDetail({ bidInvitationDocumentsCode })
                if (res.code === 200) {
                    const data = res.data || {}
                    this.fillFormFromConfig(data, { skipQuestionDeadline: true })
                    this.fillOpeningSummary(data.bidOpeningLists)
                    this.fillDirectoryTree(data.catalogues)
                    this.fillFileAttachments(data.fileGuid)
                } else {
                    console.warn('获取招标文件详情失败:', res.msg)
                }
            } catch (error) {
                console.error('获取招标文件详情失败:', error)
            }
        },

        // 获取澄清-补遗文件详情（编辑/查看模式）
        async getBidInvitationDocumentsDetail(code) {
            try {
                const res = await getClarificationDetail(code)
                if (res.code === 200) {
                    const data = res.data || {}
                    // 基础信息回填
                    this.form.applicableDocument = data.bidInvitationDocumentsCode || code
                    this.form.bidInvitationDocumentsName = data.bidInvitationDocumentsName || this.form.bidInvitationDocumentsName
                    this.form.bidInvitationDocumentsCode = data.bidInvitationDocumentsCode || this.form.bidInvitationDocumentsCode
                    this.form.content = data.content

                    // 公共回填：时间、限价、暗标、开标一览表、目录树、附件
                    this.fillFormFromConfig(data)
                    this.fillOpeningSummary(data.bidOpeningLists)
                    this.fillDirectoryTree(data.catalogues)
                    this.fillFileAttachments(data.fileGuid)

                    // 适用标段回填
                    const sectionList = Array.isArray(data.bidSectionList) ? data.bidSectionList : []
                    const selectedCodes = sectionList
                        .filter(item => Number(item.isSelected) === 1 && item.bidSectionCode)
                        .map(item => item.bidSectionCode)
                    if (selectedCodes.length > 0) {
                        this.form.bidSection = selectedCodes
                    }
                } else {
                    this.$handleApiError(res, '获取澄清-补遗 文件数据失败', this)
                }
            } catch (error) {
                this.$handleError(error, '获取澄清-补遗 文件数据失败', this)
            }
        },

        getFileList(fileGuid) {
            getFileList(fileGuid).then(res => {
                if (res.code === 200 && res.data) {
                    const list = Array.isArray(res.data) ? res.data : []
                    this.uploadedFiles = list.map(file => ({
                        fileId: file.fileId,
                        fileName: file.fileName,
                        fileType: (file.fileExtension || file.fileName?.split('.').pop() || '').toLowerCase() || '其他',
                        tenderFileType: file.fileType || '',
                        uploadTime: '-',
                        uploader: '-',
                        fileUrl: file.fileUrl,
                        fileExtension: file.fileExtension,
                        fileSize: file.fileSize
                    }))
                } else {
                    this.uploadedFiles = []
                }
            }).catch(error => {
                console.error('获取附件列表失败:', error)
                this.uploadedFiles = []
            })
        },

        // 下载已上传文件
        handleDownloadUploadedFile(row) {
            if (row && row.fileUrl) {
                window.open(row.fileUrl, '_blank')
                return
            }
            this.$message.warning('文件下载链接不存在')
        },

        // 加载项目详情
        async loadProjectDetail() {
            try {
                const res = await getProjectDetail({ projectCode: this.projectCode })
                if (res.code === 200) {
                    this.projectDetail = res.data
                    this.pageTitle = this.generatePageTitle(res.data)
                    this.form.projectName = res.data.projectName
                } else {
                    this.$handleApiError(res, '获取项目详情失败', this)
                }
            } catch (error) {
                this.$handleError(error, '获取项目详情失败', this)
            }
        },

        // 生成页面标题
        generatePageTitle(projectData) {
            const projectTypeName = getProjectTypeName(projectData.projectType)
            return `${projectTypeName}--招标项目编号：${projectData.projectCode}　招标项目名称：${projectData.projectName}`
        },

        // ==================== 表单提交相关 ====================

        // 提交表单
        handleSubmit(status) {
            if (this.isViewMode) {
                return
            }

            // 暂存时只验证基本字段
            if (status === 0) {
                // 暂存时只检查招标文件名称
                if (!this.form.bidInvitationDocumentsName) {
                    this.$message.error('请输入澄清公告名称')
                    return
                }
                if (!this.$route.query.bidInvitationDocumentsCode && !this.matchedDocument) {
                    this.$message.error('请选择适用招标文件')
                    return
                }
                this.submitBidFile(status)
                return
            }
            if (!this.$route.query.bidInvitationDocumentsCode && !this.matchedDocument) {
                this.$message.error('请选择适用招标文件')
                return
            }

            // 提交时验证所有必填字段
            this.$refs.form.validate((valid) => {
                if (valid) {
                    // 检查是否有投标文件目录
                    if (this.directoryData.treeData.length === 0) {
                        this.$message.error('请添加投标文件目录')
                        return
                    }
                    // 检查是否上传了文件
                    if (this.uploadedFiles.length === 0) {
                        this.$message.error('请上传招标文件')
                        return
                    }
                    // 校验招标文件（必须包含 PDF 和 Word）
                    if (!this.validateTenderFiles()) {
                        return
                    }
                    this.submitBidFile(status)
                } else {
                    this.$message.error('请完善必填信息')
                }
            })
        },

        // 校验招标文件（必须包含正文 PDF 和 Word 各 1 份）
        validateTenderFiles() {
            const hasPdf = this.hasPdfMain
            const hasWord = this.hasWordMain

            if (!hasPdf && !hasWord) {
                this.$message.error('请上传招标文件正文的 PDF 和 Word 文件')
                return false
            }
            if (!hasPdf) {
                this.$message.error('请上传招标文件正文的 PDF 文件')
                return false
            }
            if (!hasWord) {
                this.$message.error('请上传招标文件正文的 Word 文件')
                return false
            }
            return true
        },

        // 提交招标文件数据
        async submitBidFile(status) {
            const formData = this.prepareFormData(status)
            // 公共必传字段
            formData.fileGuid = this.fileBindId
            formData.documentPreparationStatus = status
            formData.documentType = 3
            formData.bidDocumentList = [
                {
                    bidInvitationDocumentsCode: this.matchedDocument.bidInvitationDocumentsCode,
                    bidInvitationDocumentsName: this.matchedDocument.bidInvitationDocumentsName,
                    channelCode: this.channelCode
                }
            ]
            this.operationStatus.isSubmitting = true
            try {
                const res = await addBidInvitationDocumentsClarification(formData)
                if (res.code === 200) {
                    this.$message.success(status === 1 ? '提交成功' : '暂存成功')
                    this.handleBack()
                } else {
                    this.$handleApiError(res, '操作失败', this)
                }
            } catch (error) {
                this.$handleError(error, '操作失败', this)
            } finally {
                this.operationStatus.isSubmitting = false
            }
        },

        // 准备表单数据
        prepareFormData(status) {

            const formData = {}

            // 1. 项目基础信息 & 状态
            if (this.projectCode) {
                formData.projectCode = this.projectCode
            }
            if (this.projectDetail && this.projectDetail.id) {
                formData.projectId = this.projectDetail.id
            }
            if (this.form.bidInvitationDocumentsName) {
                formData.bidInvitationDocumentsName = this.form.bidInvitationDocumentsName
            }
            // 编辑模式：带上原文件编号
            const bidInvitationDocumentsCode = this.$route.query.bidInvitationDocumentsCode
            if (bidInvitationDocumentsCode) {
                formData.bidInvitationDocumentsCode = bidInvitationDocumentsCode
            }
            formData.status = status != null ? status : 0

            // 2. 标段配置（有值才组装）
            let bidSectionConfig = null
            if (this.form.deadline) {
                const openingTime = timeUtils.formatTime(this.form.deadline)
                formData.bidOpeningTime = openingTime
                bidSectionConfig = bidSectionConfig || {}
                bidSectionConfig.bidOpeningTime = openingTime
            }
            if (this.form.decryptionDeadline) {
                const decryptionTime = timeUtils.formatTime(this.form.decryptionDeadline)
                formData.decryptionDeadline = decryptionTime
                bidSectionConfig = bidSectionConfig || {}
                bidSectionConfig.decryptionDeadline = decryptionTime
            }
            if (this.form.questionDeadline) {
                const questionDeadlineTime = timeUtils.formatTime(this.form.questionDeadline)
                formData.questionDeadline = questionDeadlineTime
                bidSectionConfig = bidSectionConfig || {}
                bidSectionConfig.questionDeadline = questionDeadlineTime
            }
            if (this.form.tenderControlPrice) {
                bidSectionConfig = bidSectionConfig || {}
                bidSectionConfig.tenderControlPrice = Number(this.form.tenderControlPrice)
                bidSectionConfig.tenderControlPriceType = this.form.tenderControlPriceType
                bidSectionConfig.tenderControlPriceUnit = this.form.tenderControlPriceType === 1
                    ? this.form.tenderControlPriceUnit
                    : 3
            }
            // 暗标标志有值就传
            if (typeof this.form.isBlindBid === 'boolean') {
                bidSectionConfig = bidSectionConfig || {}
                bidSectionConfig.isBlindReview = this.form.isBlindBid ? 1 : 0
            }
            if (bidSectionConfig) {
                formData.bidSectionConfig = bidSectionConfig
            }

            // 3. 开标一览表（仅在有数据时传）
            if (Array.isArray(this.openingSummaryData) && this.openingSummaryData.length > 0) {
                const bidOpeningLists = this.openingSummaryData.map((item, index) => {
                    return {
                        itemInstructions: item.instructions || '', // 填报说明
                        itemKey: index + 1, // key，序号
                        itemName: item.name, // 名称
                        itemType: TYPE_MAPPING[item.type] || '9', // 类型映射
                        itemUnit: UNIT_MAPPING[item.unit] || 0, // 单位映射
                        itemValueType: VALUE_TYPE_MAPPING[item.valueType] || 0, // 填报内容类型
                        status: status.toString() // 状态，0：暂存，1：提交
                    }
                })
                formData.bidOpeningLists = bidOpeningLists
            }

            // 4. 目录树（仅在有目录时传）
            const catalogues = this.buildCataloguesTree()
            if (Array.isArray(catalogues) && catalogues.length > 0) {
                formData.catalogues = catalogues
            }

            // 5. 选中标段（如果需要，可以按后端约定传 bidSections / bidSectionList，这里只在有选择时传）
            const bidSections = this.prepareBidSections()
            if (Array.isArray(bidSections) && bidSections.length > 0) {
                formData.bidSections = bidSections
            }

            // 6. 澄清内容（有内容时才传）
            if (this.form.content) {
                formData.content = this.form.content
            }

            // 7. 暗标编制要求
            if (this.form.remark) {
                formData.remark = this.form.remark
            }

            return formData
        },

        // 构建提交给后端的目录树 catalogues
        buildCataloguesTree() {
            const createTime = timeUtils.formatTime(new Date())
            const singleBidSectionCode = Array.isArray(this.form.bidSection) && this.form.bidSection.length === 1
                ? this.form.bidSection[0]
                : ''
            let autoIncrementCode = 1
            const makeNode = (node, parentCode, order, isBlindReview = 0) => {
                const catalogueCode = autoIncrementCode++
                const mapped = {
                    isBlindReview: isBlindReview,
                    idInvitationDocumentsCode: '',
                    bidSectionCode: singleBidSectionCode || '',
                    catalogueCode: catalogueCode,
                    catalogueDescription: node.name,
                    catalogueName: node.name,
                    catalogueOrder: typeof order === 'number' ? order : 0,
                    catalogueParentCode: parentCode || 0,
                    children: [],
                    createTime: createTime
                }
                if (Array.isArray(node.children) && node.children.length > 0) {
                    mapped.children = node.children.map((child, index) =>
                        makeNode(child, catalogueCode, index + 1, isBlindReview)
                    )
                }
                return mapped
            }
            const normalCatalogues = Array.isArray(this.directoryData.treeData)
                ? this.directoryData.treeData.map((root, index) => makeNode(root, 0, index + 1, 0))
                : []
            if (!this.isBlindReviewEnabled) {
                return normalCatalogues
            }
            const blindCatalogues = Array.isArray(this.directoryData.blindTreeData)
                ? this.directoryData.blindTreeData.map((root, index) => makeNode(root, 0, index + 1, 1))
                : []
            return [...normalCatalogues, ...blindCatalogues]
        },

        //准备标段数据
        prepareBidSections() {
            const bidSections = []
            if (this.form.bidSection && this.form.bidSection.length > 0) {
                // 找到用户选择的所有标段对象
                this.form.bidSection.forEach(bidSectionCode => {
                    const selectedBidSection = this.bidSectionList.find(item => item.bidSectionCode === bidSectionCode)
                    if (selectedBidSection) {
                        bidSections.push(selectedBidSection)
                    }
                })
            }
            return bidSections
        },

        // 切换限价类型（金额/费率）
        handlePriceTypeChange(type) {
            if (type === 2) {
                this.form.tenderControlPriceUnit = 3
            } else {
                this.form.tenderControlPriceUnit = 0
            }
        },

        // ==================== 表单验证相关 ====================

        validateRichTextContent(rule, value, callback) {
            const text = String(value || '')
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/gi, '')
                .trim()
            if (!text) {
                callback(new Error('请输入澄清内容'))
                return
            }
            callback()
        },

        // 自定义投标限价校验
        validateBidLimit(rule, value, callback) {
            if (!value) {
                callback(new Error('请输入投标限价'))
            } else if (!/^[0-9]+(\.[0-9]+)?$/.test(value)) {
                callback(new Error('请输入有效的数字'))
            } else {
                callback()
            }
        },

        // 自定义解密截止时间校验
        validateDecryptionDeadline(rule, value, callback) {
            if (!this.form.deadline) {
                callback(new Error('请先选择开标/递交截止时间'))
            } else if (!value) {
                callback(new Error('请选择解密截止时间'))
            } else if (!timeUtils.isValidTimeFormat(value)) {
                callback(new Error('时间格式不正确'))
            } else {
                // 检查解密截止时间是否晚于开标时间
                if (this.form.deadline && timeUtils.compareTime(value, this.form.deadline) <= 0) {
                    callback(new Error('解密截止时间必须晚于开标时间'))
                } else {
                    callback()
                }
            }
        },

        // 处理单位切换
        handleUnitChange() {
            this.$nextTick(() => {
                this.$refs.form.clearValidate('bidLimit')
            })
        },

        // 处理开标时间变化
        handleDeadlineChange() {
            if (!this.form.deadline) {
                this.form.decryptionDeadline = ''
                return
            }

            const deadlineDate = new Date(this.form.deadline.replace(/-/g, '/'))
            if (!Number.isNaN(deadlineDate.getTime())) {
                const decryptionDate = new Date(deadlineDate.getTime() + 30 * 60 * 1000)
                this.form.decryptionDeadline = timeUtils.formatTime(decryptionDate)
            }

            // 如果解密截止时间已设置，需要重新验证
            if (this.form.decryptionDeadline) {
                this.$nextTick(() => {
                    this.$refs.form.validateField('decryptionDeadline')
                })
            }
        },

        // 处理解密截止时间变化
        handleDecryptionDeadlineChange() {
            // 如果开标时间已设置，需要重新验证
            if (this.form.deadline) {
                this.$nextTick(() => {
                    this.$refs.form.validateField('deadline')
                })
            }
        },

        // ==================== 文件上传相关 ====================

        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 文件上传
        handleUpload(type, fileType) {
            if (this.isViewMode) {
                return
            }
            // 保存文件类型标识，用于后续上传
            this.tenderFileType = fileType
            // 创建文件输入框，type 用于限制文件类型
            this.createFileInput(type, fileType)
        },

        // 创建文件输入框
        createFileInput(type, fileType) {
            // 根据 type 设置 accept 属性，限制文件上传类型
            let acceptTypes = ''
            if (type === 'word') {
                acceptTypes = '.doc,.docx'
            } else if (type === 'pdf') {
                acceptTypes = '.pdf'
            } else if (type === 'attachment') {
                acceptTypes = this.uploadConstants.SUPPORTED_FILE_TYPES
            } else {
                acceptTypes = this.uploadConstants.SUPPORTED_FILE_TYPES
            }
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = acceptTypes
            input.onchange = (e) => {
                this.handleFileSelect(e, type, fileType)
            }
            input.click()
        },

        // 处理文件选择
        async handleFileSelect(event, type, fileType) {
            const file = event.target.files[0]
            if (!file || !this.validateFile(file, type)) return
            try {
                this.showUploadProgress(file)
                // fileType 作为上传时的入参传递
                const uploadResult = await this.uploadFileWithChunks(file, fileType)
                this.handleUploadResult(uploadResult, file, type, fileType)
            } catch (error) {
                this.handleUploadError(error, file)
            }
        },

        // 验证文件
        validateFile(file, type) {
            const maxSize = 102400 * 1024 * 1024
            if (file.size > maxSize) {
                this.$message.error('文件大小不能超过10GB')
                return false
            }
            // 根据 type 验证文件扩展名
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
            let allowedTypes = []
            if (type === 'word') {
                allowedTypes = ['.doc', '.docx']
            } else if (type === 'pdf') {
                allowedTypes = ['.pdf']
            } else if (type === 'attachment') {
                allowedTypes = this.uploadConstants.SUPPORTED_FILE_TYPES.split(',')
            } else {
                allowedTypes = this.uploadConstants.SUPPORTED_FILE_TYPES.split(',')
            }
            if (!allowedTypes.includes(fileExtension)) {
                const typeName = type === 'word' ? 'Word' : type === 'pdf' ? 'PDF' : '附件'
                this.$message.error(`请上传${typeName}格式的文件`)
                return false
            }
            return true
        },

        // 显示上传进度
        showUploadProgress(file) {
            this.uploadProgress = {
                visible: true,
                percentage: 0,
                fileName: file.name,
                status: this.uploadConstants.UPLOAD_STATUS.UPLOADING
            }
        },

        // 上传文件（分块上传）
        async uploadFileWithChunks(file, fileType) {
            file.fileType = fileType
            let uploadedFileId = null
            const uploadResult = await doFileUpload(file, {
                fileBindId: this.fileBindId,
                onProgress: (progress) => {
                    this.uploadProgress.percentage = Math.round(Number(progress) || 0)
                },
                onSuccess: (r) => {
                    uploadedFileId = r.fileId || r.id || ''
                },
                onError: () => { }
            })
            if (uploadResult && uploadedFileId) {
                uploadResult.fileId = uploadedFileId
            }
            return uploadResult
        },

        // 处理上传结果
        handleUploadResult(uploadResult, file, type, fileType) {
            if (uploadResult && uploadResult.success) {
                this.uploadProgress.status = this.uploadConstants.UPLOAD_STATUS.SUCCESS
                this.uploadProgress.percentage = 100
                const fileId = uploadResult.fileId || uploadResult.id || ''
                if (fileId) {
                    this.uploadedFiles.push({
                        fileName: file.name,
                        fileType: this.getFileTypeLabel(type, file.name),
                        fileSize: file.size || 0,
                        uploadTime: new Date().toLocaleString(),
                        uploader: '当前用户',
                        fileId: fileId,
                        fileTypeCode: fileType, // 保存文件类型标识，用于上传时的入参
                        tenderFileType: this.tenderFileType // 保存文件类型标识
                    })
                }
                setTimeout(() => {
                    this.uploadProgress.visible = false
                    this.$message.success(`文件 ${file.name} 上传成功`)
                }, 1000)
            } else {
                this.uploadProgress.status = this.uploadConstants.UPLOAD_STATUS.ERROR
                setTimeout(() => {
                    this.uploadProgress.visible = false
                    this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
                }, 1000)
            }
        },

        // 处理上传错误
        handleUploadError(error, file) {
            this.uploadProgress.status = this.uploadConstants.UPLOAD_STATUS.ERROR
            setTimeout(() => {
                this.uploadProgress.visible = false
                this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
            }, 1000)
        },

        // 格式化文件大小
        formatFileSize(bytes) {
            if (!bytes && bytes !== 0) return '-'
            if (bytes === 0) return '0 KB'
            const kb = bytes / 1024
            return kb < 1 ? '< 1 KB' : kb.toFixed(1) + ' KB'
        },

        // 获取文件类型标签
        getFileTypeLabel(fileType, fileName) {
            if (fileName) {
                const ext = fileName.split('.').pop()
                if (ext && ext !== fileName) return ext.toLowerCase()
            }
            const typeMap = {
                'word': 'word',
                'pdf': 'pdf',
                'attachment': '附件'
            }
            return typeMap[fileType] || '其他'
        },

        // 删除文件
        handleDeleteFile(row) {

            if (this.isViewMode) {
                return
            }
            this.deleteAndDecryptAtt(row)
        },


        deleteAndDecryptAtt(row) {
            this.$confirm(`确定要删除附件 "${row.fileName}" 吗？`, '删除确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await deleteBidAtt(row.fileId)
                    if (res.code === 200) {
                        const index = this.uploadedFiles.findIndex(item => item.fileId === row.fileId)
                        if (index > -1) {
                            this.uploadedFiles.splice(index, 1)
                            this.$message.success('删除成功')
                        }
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (error) {
                    console.error('删除附件失败:', error)
                    this.$message.error('删除失败：' + (error.message || '未知错误'))
                }
            }).catch(() => {
                // 用户取消删除
            })
        },

        // ==================== 开标一览表相关 ====================

        // 编辑开标内容项
        editSummaryItem(index) {
            const item = this.openingSummaryData[index]
            // 保存原始数据，用于取消时恢复
            this.$set(this.openingSummaryData, index, {
                ...item,
                isEditing: true,
                _originalData: {
                    name: item.name,
                    unit: item.unit,
                    instructions: item.instructions
                }
            })
        },

        // 取消编辑开标内容项
        cancelEditSummaryItem(index) {
            const item = this.openingSummaryData[index]
            if (item._originalData) {
                // 恢复原始数据
                this.$set(this.openingSummaryData, index, {
                    ...item,
                    name: item._originalData.name,
                    unit: item._originalData.unit,
                    instructions: item._originalData.instructions,
                    isEditing: false,
                    _originalData: undefined
                })
            } else {
                // 如果没有原始数据，直接退出编辑模式
                this.$set(this.openingSummaryData, index, {
                    ...item,
                    isEditing: false
                })
            }
            this.$message.info('已取消编辑')
        },

        // 保存开标内容项
        saveSummaryItem(index) {
            const item = this.openingSummaryData[index]
            if (!item.name || !item.valueType || !item.unit || !item.instructions) {
                this.$message.error('请填写完整信息')
                return
            }
            // 移除 isNew 和 isEditing 标记，清除原始数据，变为只读状态
            this.$set(this.openingSummaryData, index, {
                ...item,
                isNew: false,
                isEditing: false,
                _originalData: undefined
            })
            this.$message.success('保存成功')
        },

        // 上移/下移开标内容项
        moveSummaryItem(index, direction) {
            const targetIndex = direction === 'up' ? index - 1 : index + 1
            const temp = this.openingSummaryData[index]
            this.$set(this.openingSummaryData, index, this.openingSummaryData[targetIndex])
            this.$set(this.openingSummaryData, targetIndex, temp)
        },

        // 删除开标内容项
        deleteSummaryItem(index) {
            this.$confirm('确定要删除此项吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.openingSummaryData.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },

        // 显示添加弹窗
        showAddDialog() {
            this.dialogs.add = true
            this.addDialogData.selectedType = ''
        },

        // 确认添加
        confirmAdd() {
            if (!this.addDialogData.selectedType) {
                this.$message.error('请选择自定义内容的类型')
                return
            }

            const selectedType = this.addDialogData.selectedType

            const config = this.typeConfig[selectedType]

            // 添加原有的项
            const newItem = {
                name: selectedType,
                valueType: config.valueType,
                unit: config.unit,
                instructions: '',
                type: selectedType,
                isNew: true
            }
            this.openingSummaryData.push(newItem)

            // 如果选择的是"单价"，额外添加"单价（大写）"
            if (selectedType === '单价') {
                const capitalItem = {
                    name: '单价（大写）',
                    valueType: '任意格式文本',
                    unit: '元',
                    instructions: '',
                    type: '其他',
                    isNew: true
                }
                this.openingSummaryData.push(capitalItem)
            }

            this.dialogs.add = false
            this.addDialogData.selectedType = ''
        },

        // 取消添加
        cancelAdd() {
            this.dialogs.add = false
            this.addDialogData.selectedType = ''
        },

        // ==================== 引用文件相关 ====================

        // 加载引用文件数据
        loadReferenceData() {
            this.referenceData.loading = true
            setTimeout(() => {
                this.referenceData.loading = false
            }, 500)
        },

        // 选择引用文件
        handleSelectReference(row) {
            this.form.referenceFile = row.fileName
            this.$message.success(`已选择引用文件: ${row.fileName}`)
            this.dialogs.reference = false
        },

        // 取消选择引用文件
        handleCancelReference() {
            this.dialogs.reference = false
        },

        // 引用文件分页大小改变
        handleReferenceSizeChange(val) {
            this.referenceData.pagination.pageSize = val
            this.loadReferenceData()
        },

        // 引用文件当前页改变
        handleReferenceCurrentChange(val) {
            this.referenceData.pagination.currentPage = val
            this.loadReferenceData()
        },

        // ==================== 目录管理相关 ====================

        // 显示目录管理弹窗
        showDirectoryDialog() {
            this.dialogs.directory = true
            // 如果目录数据为空，初始化一个空数组
            if (this.directoryData.treeData.length === 0) {
                this.directoryData.treeData = []
            }
        },

        // 添加根目录
        addRootDirectory(treeTarget) {
            const newDirectory = {
                id: Date.now(),
                name: '新建目录',
                children: []
            }
            if (treeTarget === 'blind') {
                this.directoryData.blindTreeData.push(newDirectory)
            } else {
                this.directoryData.treeData.push(newDirectory)
            }
            // 自动进入编辑状态
            this.$nextTick(() => {
                this.editDirectoryName(newDirectory)
            })
        },

        // 删除暗标根目录
        deleteBlindDirectory(node, index) {
            this.$confirm('确定要删除该目录及其所有子目录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.directoryData.blindTreeData.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },

        // 根据选中标段同步暗标状态
        syncBlindReviewBySelectedSection() {
            if (!Array.isArray(this.form.bidSection) || this.form.bidSection.length === 0) {
                this.form.isBlindBid = false
                return
            }
            const isBlind = this.form.bidSection.some(code => {
                const section = this.bidSectionList.find(s => s.bidSectionCode === code)
                return section && Number(section.isBlindReview || 0) === 1
            })
            this.form.isBlindBid = isBlind
        },

        // 添加子目录
        addChildDirectory(parent) {
            if (!parent.children) {
                this.$set(parent, 'children', [])
            }
            const newChild = {
                id: Date.now() + Math.random(),
                name: '新建子目录',
                children: []
            }
            parent.children.push(newChild)
            // 自动进入编辑状态
            this.$nextTick(() => {
                this.editDirectoryName(newChild)
            })
        },

        // 编辑目录名称
        editDirectoryName(node) {
            this.directoryData.editingNode = node
            this.directoryData.editingName = node.name
            // 聚焦输入框
            this.$nextTick(() => {
                const inputs = this.$refs.directoryInput
                if (inputs) {
                    const inputArray = Array.isArray(inputs) ? inputs : [inputs]
                    const currentInput = inputArray.find(inp => {
                        if (inp && inp.$el) {
                            const inputEl = inp.$el.querySelector('input')
                            return inputEl && inputEl.value === node.name
                        }
                        return false
                    })
                    if (currentInput && currentInput.$el) {
                        const inputEl = currentInput.$el.querySelector('input')
                        if (inputEl) {
                            inputEl.focus()
                            inputEl.select()
                        }
                    } else if (inputArray.length > 0 && inputArray[0].$el) {
                        // 如果找不到匹配的，就聚焦第一个
                        const inputEl = inputArray[0].$el.querySelector('input')
                        if (inputEl) {
                            inputEl.focus()
                            inputEl.select()
                        }
                    }
                }
            })
        },

        // 保存目录名称
        saveDirectoryName(node) {
            if (!this.directoryData.editingName || this.directoryData.editingName.trim() === '') {
                this.$message.warning('目录名称不能为空')
                // 如果名称为空，恢复原名称
                this.directoryData.editingName = node.name
                return
            }
            node.name = this.directoryData.editingName.trim()
            this.directoryData.editingNode = null
            this.directoryData.editingName = ''
        },

        // 删除目录
        deleteDirectory(node, index) {
            this.$confirm('确定要删除该目录及其所有子目录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.directoryData.treeData.splice(index, 1)
                this.$message.success('删除成功')
            }).catch(() => {
                this.$message.info('已取消删除')
            })
        },

        // 删除子目录
        deleteChildDirectory(parent, child, childIndex) {
            this.$confirm('确定要删除该目录及其所有子目录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (parent && parent.children) {
                    parent.children.splice(childIndex, 1)
                    this.$message.success('删除成功')
                }
            }).catch(() => {})
        },

        // 删除三级子目录
        deleteGrandchildDirectory(parent, grandchild, grandchildIndex) {
            this.$confirm('确定要删除该目录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (parent && parent.children) {
                    parent.children.splice(grandchildIndex, 1)
                    this.$message.success('删除成功')
                }
            }).catch(() => {})
        },

        // 确认目录设置
        confirmDirectory() {
            // 检查是否有正在编辑的目录
            if (this.directoryData.editingNode) {
                this.saveDirectoryName(this.directoryData.editingNode)
            }
            // 这里可以保存目录数据到表单或发送到后端
            console.log('目录数据:', JSON.stringify(this.directoryData.treeData, null, 2))
            this.$message.success('目录设置已保存')
            this.dialogs.directory = false
        },

        // 打开粘贴目录弹窗
        openPasteDirectoryDialog(treeTarget) {
            this.directoryData.pasteTarget = treeTarget || 'normal'
            this.dialogs.pasteDirectory = true
        },

        // 取消粘贴目录
        cancelPasteDirectory() {
            this.dialogs.pasteDirectory = false
        },

        // 确认粘贴目录并生成树
        confirmPasteDirectory() {
            const content = String(this.directoryData.pasteContent || '').trim()
            if (!content) {
                this.$message.warning('请先粘贴目录内容')
                return
            }

            const parsedTree = this.parseDirectoryText(content)
            if (!parsedTree.length) {
                this.$message.warning('未识别到有效目录，请检查格式')
                return
            }

            if (this.directoryData.pasteTarget === 'blind') {
                this.directoryData.blindTreeData = parsedTree
            } else {
                this.directoryData.treeData = parsedTree
            }
            this.dialogs.pasteDirectory = false
            this.$message.success('目录生成成功')
        },

        // 解析粘贴的目录文本
        parseDirectoryText(text) {
            const lines = text
                .split(/\r?\n/)
                .map(line => line.trim())
                .filter(Boolean)

            const roots = []
            let currentRoot = null

            const normalizeName = (rawLine) => rawLine
                .replace(/^[一二三四五六七八九十百千万零〇两]+[、.．)）]\s*/, '')
                .replace(/^\d+[、.．)）]\s*/, '')
                .replace(/^\(?\d+\)?\s*/, '')
                .replace(/^[（(]\d+[）)]\s*/, '')
                .trim()

            const createNode = (name) => ({
                id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
                name,
                children: []
            })

            lines.forEach((line) => {
                const isLevel1 = /^[一二三四五六七八九十百千万零〇两]+[、.．)）]/.test(line)
                const isLevel2 = /^\d+[、.．)）]/.test(line) || /^[（(]\d+[）)]/.test(line)
                const name = normalizeName(line)
                if (!name) return

                if (isLevel1 || !currentRoot) {
                    const rootNode = createNode(name)
                    roots.push(rootNode)
                    currentRoot = rootNode
                    return
                }

                if (isLevel2 && currentRoot) {
                    currentRoot.children.push(createNode(name))
                    return
                }

                const rootNode = createNode(name)
                roots.push(rootNode)
                currentRoot = rootNode
            })

            return roots
        },

        // 取消目录设置
        cancelDirectory() {
            // 如果有正在编辑的目录，取消编辑
            if (this.directoryData.editingNode) {
                this.directoryData.editingNode = null
                this.directoryData.editingName = ''
            }
            this.dialogs.directory = false
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-title {
    font-size: 16px;
    font-weight: 600;
    color: @gray-700;
    margin: 0;
    line-height: 1.5;
    position: relative;
    padding-left: 10px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: @primary-color;
        border-radius: 2px;
    }

    &:nth-child(2)::before {
        background: @gray-700;
    }
}

.content-wrap {
    width: 100%;
    height: 100%;
    background: #fff;
    padding: 30px;
    border-radius: 4px;
    box-shadow: @shadow-sm;
    margin-top: 20px;
}

// 表单样式
.bid-form {
    .form-row {
        display: flex;
        gap: 40px;
        text-align: start;
    }

    .form-column {
        flex: 1;
    }

    .el-form-item {
        margin-bottom: 20px;

        .el-form-item__label {
            color: @gray-700;
            font-weight: 500;
        }
    }

    .el-input__inner,
    .el-textarea__inner {
        border-color: @gray-300;
        color: @gray-700;

        &:focus {
            border-color: @primary-color;
        }

        &::placeholder {
            color: @gray-400;
        }

        &:disabled {
            background-color: @gray-100;
            color: @gray-500;
        }
    }

    .upload-tip {
        color: @error-color;
        font-size: 12px;
        margin: 0 5px;
    }

    .upload-section {
        width: 100%;

        .upload-buttons {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 10px;
        }

        .uploaded-files-list {
            margin-top: 15px;

            .file-group {
                margin-top: 16px;

                &:first-child {
                    margin-top: 12px;
                }

                .file-group-header {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    font-size: 13px;
                    font-weight: 600;
                    color: #606266;
                    margin-bottom: 8px;
                    padding: 6px 10px;
                    background: #f5f7fa;
                    border-radius: 4px;

                    i {
                        font-size: 14px;
                        color: #409EFF;
                    }
                }
            }

            .el-table {
                font-size: 13px;
                border: 1px solid @gray-200;
                border-radius: 4px;

                /deep/ .el-table__header {
                    th {
                        background-color: @gray-100;
                        color: @gray-700;
                        font-weight: 600;
                    }
                }
            }
        }
    }
}

// 投标文件章节对应样式
.section-header {
    display: flex;
    align-items: center;
    margin: 30px 0 20px 0;

    .section-title {
        font-size: 16px;
        margin-right: 20px;
        font-weight: 600;
        color: @gray-700;
        padding-left: 10px;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }
    }
}

// 开标一览表样式
.opening-summary {
    margin-bottom: 30px;

    .summary-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin-bottom: 15px;
        padding-left: 10px;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }
    }

    .add-summary-btn {
        margin-top: 25px;
        text-align: center;
    }

    .el-table {
        border: 1px solid @gray-200;
        border-radius: 4px;

        /deep/ .el-table__header {
            th {
                background-color: @gray-100;
                color: @gray-700;
                font-weight: 600;
            }
        }

        /deep/ .el-table__body {
            tr:hover {
                background-color: @gray-50;
            }
        }
    }

    .el-button--text {
        padding: 0;
        margin: 0 5px;
        color: @primary-color;

        &:hover {
            color: @primary-hover;
        }

        i {
            font-size: 16px;
        }
    }
}

// 复选框和单选框样式
.el-radio-group {
    .el-radio {
        margin-right: 20px;

        .el-radio__label {
            font-size: 14px;
            color: @gray-600;
        }

        .el-radio__input {
            &.is-checked .el-radio__inner {
                border-color: @primary-color;
                background: @primary-color;
            }

            &.is-checked+.el-radio__label {
                color: @primary-color;
            }
        }
    }
}

.el-checkbox {
    .el-checkbox__label {
        font-size: 14px;
        color: @gray-600;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: @primary-color;
        border-color: @primary-color;
    }
}

// 底部按钮样式
.form-actions {
    text-align: center;
    margin-top: 40px;
    padding-top: 20px;
    border-top: 1px solid @gray-200;

    .el-button {
        margin: 0 10px;
        padding: 12px 40px;

        &.el-button--primary {
            background-color: @primary-color;
            border-color: @primary-color;

            &:hover {
                background-color: @primary-hover;
                border-color: @primary-hover;
            }
        }

        &:not(.el-button--primary) {
            background-color: #fff;
            border-color: @gray-300;
            color: @gray-600;

            &:hover {
                color: @primary-color;
                border-color: @primary-color;
                background-color: @primary-light;
            }
        }
    }
}

// 添加弹窗样式
.add-dialog {
    /deep/ .el-dialog__header {
        padding: 16px 20px;
        border-bottom: 1px solid @gray-200;
        background: @gray-50;

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: @gray-700;
        }

        .el-dialog__close {
            font-size: 18px;
            color: @gray-500;

            &:hover {
                color: @gray-700;
            }
        }
    }

    /deep/ .el-dialog__body {
        padding: 20px;
    }

    /deep/ .el-dialog__footer {
        padding: 15px 20px 20px;
        text-align: center;
        border-top: 1px solid @gray-200;
    }
}

.dialog-content {
    .dialog-title {
        font-size: 14px;
        color: @gray-700;
        margin-bottom: 20px;
        font-weight: 500;
    }

    .type-radio-group {
        .radio-row {
            display: flex;
            margin-bottom: 15px;

            .el-radio {
                margin-right: 30px;
                margin-bottom: 0;

                .el-radio__label {
                    font-size: 14px;
                    color: @gray-600;
                }
            }
        }
    }

    .error-message {
        color: @error-color;
        font-size: 12px;
        margin-top: 10px;
    }
}

.dialog-footer {
    .el-button {
        padding: 10px 25px;
        font-size: 14px;

        &.el-button--primary {
            background-color: @primary-color;
            border-color: @primary-color;

            &:hover {
                background-color: @primary-hover;
                border-color: @primary-hover;
            }
        }

        &:not(.el-button--primary) {
            background-color: #fff;
            border-color: @gray-300;
            color: @gray-600;

            &:hover {
                color: @primary-color;
                border-color: @primary-color;
                background-color: @primary-light;
            }
        }
    }
}

// 引用弹窗样式
.reference-dialog {
    /deep/ .el-dialog__header {
        padding: 16px 20px;
        border-bottom: 1px solid @gray-200;
        background: @gray-50;

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: @gray-700;
        }
    }

    .dialog-content {
        padding: 0;
    }

    .reference-table {
        margin-bottom: 20px;
        border: 1px solid @gray-200;
        border-radius: 4px;

        /deep/ .el-table__header {
            th {
                background-color: @gray-100;
                color: @gray-700;
                font-weight: 600;
            }
        }
    }

    .select-btn {
        color: @primary-color;
        font-weight: 500;

        &:hover {
            color: @primary-hover;
        }
    }

    .reference-pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;

        .reference-pagination-controls {
            margin-left: auto;
        }
    }

    .dialog-footer {
        text-align: right;
        padding: 10px 0 0 0;
    }
}

// 目录管理弹窗样式
.directory-dialog {
    /deep/ .el-dialog__header {
        padding: 16px 20px;
        border-bottom: 1px solid @gray-200;
        background: @gray-50;

        .el-dialog__title {
            font-size: 16px;
            font-weight: 600;
            color: @gray-700;
        }
    }

    .dialog-content {
        padding: 5px;
        min-height: 300px;
    }

    .directory-toolbar {
        margin-bottom: 20px;
        text-align: left;

        .el-button+.el-button {
            margin-left: 10px;
        }
    }

    .directory-tree {
        min-height: 300px;
        max-height: 500px;
        overflow-y: auto;
        border: 1px solid @gray-200;
        border-radius: 4px;
        padding: 10px;
        background-color: @gray-50;
    }

    .empty-directory {
        text-align: center;
        padding: 60px 20px;
        color: @gray-500;

        i {
            font-size: 48px;
            color: @gray-400;
            margin-bottom: 15px;
            display: block;
        }

        p {
            font-size: 14px;
            margin: 0;
        }
    }

    .directory-list {
        .directory-item {
            margin-bottom: 8px;

            &.child-item {
                margin-left: 30px;
                margin-top: 8px;
            }

            &.grandchild-item {
                margin-left: 30px;
                margin-top: 8px;
            }
        }

        .directory-node {
            display: flex;
            align-items: center;
            padding: 8px 12px;
            background-color: #fff;
            border: 1px solid @gray-200;
            border-radius: 4px;
            transition: all @transition-base ease;

            &:hover {
                background-color: @gray-100;
                border-color: @gray-300;

                .directory-actions {
                    opacity: 1;
                }
            }

            i {
                color: @primary-color;
                font-size: 16px;
                margin-right: 8px;
            }

            .directory-name {
                flex: 1;
                font-size: 14px;
                color: @gray-700;
                min-width: 0;
                word-break: break-all;
            }

            .directory-input {
                flex: 1;
                max-width: 300px;
            }

            .directory-actions {
                display: flex;
                align-items: center;
                opacity: 0;
                transition: opacity @transition-base ease;
                margin-left: 10px;

                .el-button {
                    padding: 0;
                    margin-left: 8px;
                    color: @gray-600;

                    &:hover {
                        color: @primary-color;
                    }
                }
            }
        }

        .directory-children {
            margin-top: 8px;
        }
    }
}

.paste-directory-dialog {
    .paste-directory-content {
        .paste-directory-tip {
            margin-bottom: 10px;
            font-size: 13px;
            color: @gray-600;
            text-align: left;
        }
    }
}

.rich-text-readonly {
    min-height: 120px;
    padding: 10px 12px;
    line-height: 1.6;
    color: @gray-700;
    background: @gray-100;
    border: 1px solid @gray-200;
    border-radius: 4px;
    word-break: break-word;
}

// 文件上传进度对话框样式
.upload-progress-content {
    padding: 20px;

    .upload-info {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        font-size: 14px;
        color: @gray-700;

        i {
            font-size: 24px;
            color: @primary-color;
            margin-right: 10px;
        }
    }

    .upload-status {
        font-size: 14px;
        color: @gray-600;
    }
}
</style>